import React from 'react';
import { ImportUserRowStyled } from './styled';
import { Box, Text, Checkbox } from '@bechtel/gds';
import { CrewType } from '@bechtel/types';
import { FieldArray, FormikProps } from 'formik';
import { FormikState } from '../index';
import { findIndex } from 'lodash';

interface CrewTypeListProps {
  form: FormikProps<FormikState>;
}

export const CrewTypesList: React.FC<CrewTypeListProps> = ({ form }) => {
  const crewTypes = form.values.crewTypes;

  return (
    <FieldArray name="crewTypes">
      {(arrayHelpers) => {
        return (
          <>
            {crewTypes &&
              crewTypes.map((item: CrewType) => {
                return (
                  <ImportUserRowStyled key={item.id}>
                    <Box
                      px={{ sm: '500' }}
                      py={{ sm: '500' }}
                      flexGrow={{ sm: 1 }}
                      onClick={() => {
                        const itemIndex = findIndex(crewTypes, (inner: CrewType) => {
                          return inner.id === item.id;
                        });
                        arrayHelpers.replace(itemIndex, { ...item, applicableToProject: !item.applicableToProject });
                      }}
                    >
                      <Box mr={{ sm: '600' }}>
                        <Checkbox type="checkbox" checked={item.applicableToProject} readOnly />
                      </Box>
                      <Text color="grey.1000" size="400">
                        {item.name} {!!item.description && `(${item.description})`}
                      </Text>
                    </Box>
                  </ImportUserRowStyled>
                );
              })}
          </>
        );
      }}
    </FieldArray>
  );
};
